import { StoryblokComponent } from "@trydig/storyblok";
import type { ComponentProps } from "react";
import { MARK_LINK, render } from "storyblok-rich-text-react-renderer";
import { Link } from "@/i18n/routing";
import { type LinkInsert, sbLink } from "@/lib/storyblok/link";
import type { StoryblokRichtext } from "@/storyblok";
import { Prose } from "../Prose";

export type RichTextProps = ComponentProps<"div">;

export type RichTextRendererProps = {
	blok: StoryblokRichtext | string;
	className?: string;
	preview: boolean;
};

export const RichTextRenderer = ({
	blok,
	className,
	preview,
}: RichTextRendererProps) => {
	const content =
		typeof blok === "string"
			? blok
			: render(blok, {
					defaultBlokResolver: (name, props) => (
						<div data-component-blok={name}>
							<StoryblokComponent
								blok={{ component: name, ...props }}
								preview={preview}
							/>
						</div>
					),

					markResolvers: {
						[MARK_LINK]: (children, attrs) => {
							let href = attrs.href;

							if (
								attrs.linktype === "email" &&
								!attrs.href?.startsWith("mailto:")
							) {
								href = `mailto:${attrs.href}`;
							}

							if (attrs.linktype === "story") {
								href = sbLink(attrs as LinkInsert)?.href || href;
							}

							return href ? (
								<Link href={href} target={attrs.target}>
									{children}
								</Link>
							) : (
								// biome-ignore lint/complexity/noUselessFragments: coerces ReactNode children to the Element return type the mark resolver requires
								<>{children}</>
							);
						},
					},
				});

	return <Prose className={className}>{content}</Prose>;
};
